import { Link } from 'react-router-dom';
import { useEffect, lazy, Suspense } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { loadable } from 'react-lazily/loadable';
import { getBannerMenu, getBannerBySlug } from 'reduxStore/actions';
import { bannerCategorysettings, bannerSettings, initialListState, serviceType } from 'utils/constants';
import onlinetools from 'assets/images/category/individual/onlinetools.svg';
import { RootReducerState } from 'reduxStore/rootReducers';
import bannerNoImg from 'assets/images/homepages/shrinkhala-khatiwada.png';
import { UrlFirstSegment } from 'utils/global';

const Button = lazy(() => import('components/buttons/Button'));
const { TranslationMessage } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
const { Image } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
const { NetworkStatus } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
const { ReactCarouselSlider } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});

interface Props {
	bannerListData?: [];
	serviceTypeToUse?: any;
}
// this component is shared in home page for all service type and in content page
const BannerLayout = ({ bannerListData, serviceTypeToUse }: Props) => {
	const dispatch = useDispatch();
	// const urlFirstSegment = UrlFirstSegment();
	const { bannerMenuData, bannerData } = useSelector(
		({ bannerReducer }: RootReducerState) => ({
			bannerMenuData: bannerReducer.menuData[serviceTypeToUse] ?? initialListState,
			bannerData: bannerReducer.bannerData[serviceTypeToUse] ?? initialListState,
		}),
		shallowEqual
	);

	const { loading: bannerLoading } = bannerData;
	const { data: bannerMenuList, loading: bannerMenuLoading } = bannerMenuData;

	// Define bannerList with a default empty array if it's null or undefined
	const bannerList = bannerListData?.length ? bannerListData : bannerData?.data ?? [];

	//INITALLY CALL API FOR DATA
	useEffect(() => {
		if (!bannerListData?.length) {
			dispatch(getBannerMenu(serviceTypeToUse));
			dispatch(getBannerBySlug(serviceTypeToUse));
		}
	}, [dispatch, bannerListData, serviceTypeToUse]);

	const renderClass = () => {
		if (serviceTypeToUse === 'nabilbank') {
			return 'layout1';
		}
		if (serviceTypeToUse === 'individual') {
			return 'layout2';
		} else if (serviceTypeToUse === 'business') {
			return 'layout2';
		} else if (serviceTypeToUse === serviceType.SERVICESANDPAYMENTS) {
			return 'layout3';
		}
	};

	return (
		<>
			{/* loader is only displayed at beginning of data load because banner list data is handled dynamically with service type */}
			<NetworkStatus loading={bannerList?.length > 0 ? false : bannerLoading || bannerMenuLoading} />
			{bannerList?.length > 0 && (
				<section className={`banner-section ${renderClass()}`}>
					<ReactCarouselSlider {...bannerSettings}>
						{bannerList.map((banner, bindex) => (
							<div className="main-banner" key={bindex}>
								<Image className="image-banner-img img-fluid" src={banner.back_image} alt="banner" onErrorSrc={bannerNoImg} />
								<div className="main-banner-item container">
									<div className="row h-100">
										{(banner.main_text || banner.subtitle || banner.first_btn_text || banner.second_btn_text) && (
											<div className="col-md-6 col-sm-12">
												<div className="main-banner-detail">
													<h1 className="font-weight-bold text-white mb-3 h2">
														<TranslationMessage data={banner} value="main_text" isHtmlParse />
													</h1>
													<h5 className="text-white font-weight-light mb-3">
														<TranslationMessage data={banner} value="subtitle" isHtmlParse />
													</h5>
													<div className={`main-banner-btn-wrapper ${banner.first_btn_text || banner.second_btn_text ? 'mt-3' : ''}`}>
														{banner.show_first_button == 'yes' && (
															<Suspense fallback={<div>Loading...</div>}>
																<Button buttonStyle="btn-primary--solid" type="button" classname="mr-0 mr-sm-2" url={banner.first_btn_url} icon>
																	<TranslationMessage data={banner} value="first_btn_text" />
																</Button>
															</Suspense>
														)}
														{banner.show_second_button == 'yes' && (
															<Suspense fallback={<div>Loading...</div>}>
																<Button buttonStyle="btn-primary--solid" type="button" url={banner.second_btn_url} icon>
																	<TranslationMessage data={banner} value="second_btn_text" />
																</Button>
															</Suspense>
														)}
													</div>
												</div>
											</div>
										)}
									</div>
								</div>
							</div>
						))}
					</ReactCarouselSlider>

					{bannerMenuList?.length > 0 && !bannerListData?.length ? (
						<div className="container banner-container slide-up-fade-in">
							<div className="row">
								<div className="col-lg-6 col-md-12">
									<div className="category-wrapper ">
										<ReactCarouselSlider {...bannerCategorysettings} className="cat-slide">
											{bannerMenuList.map((bannerMenu, bmindex) => {
												return (
													<div className="" key={bmindex}>
														{bannerMenu.menu_url.startsWith('https') || bannerMenu.menu_url.startsWith('http') ? (
															<a href={bannerMenu.menu_url} className="h-100 category-wrapper-item " target="_blank" rel="noreferrer">
																{bannerMenu?.icon_type === 'image' && bannerMenu.menu_image && <Image className="img-fluid" src={bannerMenu.menu_image} alt="" onErrorSrc={onlinetools} />}
																{bannerMenu?.icon_type === 'image' && bannerMenu?.menu_icon && <i className={bannerMenu?.menu_icon}></i>}
																<span>
																	<TranslationMessage data={bannerMenu} value="menu_title" />
																</span>
															</a>
														) : bannerMenu.opt_type === 'file' ? (
															<a href={process.env.REACT_APP_FILE_BASE_URI + bannerMenu.menu_url} className="h-100 category-wrapper-item " target="_blank" rel="noreferrer">
																{bannerMenu?.icon_type === 'image' && bannerMenu.menu_image && <Image className="img-fluid" src={bannerMenu.menu_image} alt="" onErrorSrc={onlinetools} />}
																{bannerMenu?.icon_type === 'image' && bannerMenu?.menu_icon && <i className={bannerMenu?.menu_icon}></i>}
																<span>
																	<TranslationMessage data={bannerMenu} value="menu_title" />
																</span>
															</a>
														) : (
															<Link to={bannerMenu.menu_url} className="h-100 category-wrapper-item ">
																{bannerMenu?.icon_type === 'image' && bannerMenu.menu_image && <Image className="img-fluid" src={bannerMenu.menu_image} alt="" onErrorSrc={onlinetools} />}
																{bannerMenu?.icon_type === 'image' && bannerMenu?.menu_icon && <i className={bannerMenu?.menu_icon}></i>}
																<span>
																	<TranslationMessage data={bannerMenu} value="menu_title" />
																</span>
															</Link>
														)}
													</div>
												);
											})}
										</ReactCarouselSlider>
									</div>
								</div>
							</div>
						</div>
					) : null}
				</section>
			)}
		</>
	);
};

export { BannerLayout };
